import { makeStyles } from '@material-ui/core'
import shadows from '@material-ui/core/styles/shadows'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    marginBottom: 12,
    zIndex: 1
  },
  rootActive: {
    zIndex: 10
  },
  deleteIconContainer: {
    position: 'absolute',
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: 'rgba(0,0,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '25%',
    right: 16,
    zIndex: 22
  },
  deleteIcon: {
    fontSize: 16,
    color: theme.palette.primary.contrastText
  },
  timePeriodInputContainer: {
    // width: 'fill-available',
    // width: '-moz-available',
    width: '100%',
    height: 51,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 3,
    paddingRight: 25,
    paddingLeft: 25,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textAlign: 'inherit'
  },
  timePeriodInputContainerLight: {
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.primary.main}`,
    paddingRight: 8,
    paddingLeft: 8,
    borderRadius: 6,
    height: 44
  },
  timePeriodInputItem: {
    flex: 1,
    '& p': {
      color: theme.palette.primary.contrastText
    }
  },
  timePeriodInputItemLight: {
    flex: 1,
    textAlign: 'center',
    borderRadius: 4,
    backgroundColor: theme.palette.primary.light
  },
  timeInputLabel: {
    color: theme.palette.primary.contrastText
  },
  timeInputLabelLight: { color: theme.palette.primary.main },
  datePickerContainer: {
    position: 'absolute',
    right: 0,
    '&>div': {
      boxShadow: shadows[3]
    }
  },
  datePickerContainerLeft: {
    position: 'absolute',
    left: 0,
    '&>div': {
      boxShadow: shadows[3]
    }
  },
  timeInputValue: {
    fontWeight: 700,
    overflow: 'hidden',
    height: 24,
    transition: 'all linear 0.2s',
    color: theme.palette.primary.contrastText,
    '& p': {
      color: theme.palette.primary.contrastText
    }
  },
  timeInputValueLight: {
    fontWeight: 700,
    overflow: 'hidden',
    height: 24,
    transition: 'all linear 0.2s',
    color: theme.palette.primary.main,
    '& p': {
      color: theme.palette.primary.main
    }
  },
  timeInputValueForRateConnection: {
    fontSize: 14
  },
  timeInputValueInvisible: {
    height: 0
  },
  daysContainer: {
    display: 'flex',
    width: '170%',
    '& p': {
      fontSize: 12
    }
  },
  daysContainerHide: {
    marginTop: 17,
    display: 'flex'
  },
  trendingIcon: { color: theme.palette.primary.main, margin: '0 8px' },
  trendingIconRtl: {
    transform: 'rotate(180deg)'
  }
}))

export default useStyles
